export const useAirbalticApi = () => {
  const runtimeConfig = useRuntimeConfig()
  const jwt = useCookie<string>(runtimeConfig.public.authCookieName)

  const baseUrl = runtimeConfig.public.airbalticApiUrl

  const api = $fetch.create({
    baseURL: baseUrl,
    onRequest({ options }) {
      if (jwt) {
        const headers = (options.headers ||= {})
        if (Array.isArray(headers)) {
          headers.push(['Authorization', `Bearer ${jwt}`])
        } else if (headers instanceof Headers) {
          headers.set('Authorization', `Bearer ${jwt}`)
        } else {
          headers.Authorization = `Bearer ${jwt}`
        }
      }
    },
    async onResponseError({ response }) {
      if (response.status === 401) {
        await navigateTo('/login')
      }
    }
  })

  return { api }
}
